import script from "./submit4.vue?vue&type=script&setup=true&lang=js"
export * from "./submit4.vue?vue&type=script&setup=true&lang=js"

import "./submit4.vue?vue&type=style&index=0&id=18457ec3&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18457ec3"]])

export default __exports__